// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"01088b36","243":"326b86c4","507":"263689d8","818":"0c33bffe"}[chunkId] + ".css";
};